import React, { type FC, type PropsWithChildren } from 'react';

type ProseWrapperProps = PropsWithChildren & {
  enableProse?: boolean;
};

export const ProseWrapper: FC<ProseWrapperProps> = (props) => {
  const { children, enableProse = false } = props;

  return enableProse ? (
    <div
      className='prose font-long-format max-w-none'
      style={{ '--bor-heading-weight': '600' } as React.CSSProperties}
    >
      {children}
    </div>
  ) : (
    <>{children}</>
  );
};
